import logoPNG from "@assets/images/logo.png";
import HeaderItem from "./components/HeaderItem";
import { appPath } from "@routes/app";
import { translation } from "@utils/translation";
import { useContext, useRef, useState } from "react";
import { AppContext } from "../appContext/AppContext";
import Icon from "@components/primitives/icon/Icon";
import { config } from "@utils/config";
import LanguageSelect from "@components/primitives/languageSelect/LanguageSelect";
import ThemeToggle from "@components/primitives/themeToggle/ThemeToggle";
import useOutsideAlerter from "@utils/useOutsideAlerter";

function Header() {
  const { language } = useContext(AppContext);
  const [isSettingsMenuOpen, setIsSettingsMenuOpen] = useState(false);
  const settingsMenuRef = useRef(null);

  const handleSettingsMenu = () => {
    setIsSettingsMenuOpen(!isSettingsMenuOpen);
  };

  useOutsideAlerter(settingsMenuRef, setIsSettingsMenuOpen, false);

  return (
    <header className="fixed p-5 flex gap-5 items-center justify-between w-full shadow-md bg-secondary z-40">
      <div className="flex gap-5 items-center w-full">
        <a href={appPath.default} className="rounded-full">
          <img src={logoPNG} className="h-[50px] m-0" alt="Logo" />
        </a>
        <div className="flex gap-5 items-center">
          {!config.isUnderConstruction && (
            <>
              <HeaderItem
                label={translation(language).header.home}
                icon={<Icon icon="home" />}
                to={appPath.default}
              />
              <HeaderItem
                label={translation(language).header.members}
                icon={<Icon icon="users" />}
                to={appPath.members}
              />
              <HeaderItem
                label={translation(language).header.events}
                icon={<Icon icon="calendar" />}
                to={appPath.events}
              />
              <HeaderItem
                label={translation(language).header.photos}
                icon={<Icon icon="image" />}
                to={appPath.photos}
              />
              <HeaderItem
                label={translation(language).header.contact}
                icon={<Icon icon="envelope" />}
                to={appPath.contact}
              />
            </>
          )}
        </div>
      </div>
      <div className="md:flex hidden w-1/2 h-full justify-end gap-5">
        <LanguageSelect />
        <ThemeToggle />
      </div>
      <div
        className="md:hidden flex h-full justify-end text-primary"
        onClick={handleSettingsMenu}
      >
        <Icon icon="gear" />
      </div>
      {isSettingsMenuOpen && (
        <div
          ref={settingsMenuRef}
          className="absolute bg-secondary w-[150px] h-fit top-16 right-5 z-50 shadow-lg border border-primary p-2 flex gap-5"
        >
          <LanguageSelect />
          <ThemeToggle />
        </div>
      )}
    </header>
  );
}

export default Header;
